import { useWatchfaceStore } from '../../store/use-watchface-store';
import { ElectronApi } from '../electron.api';
import { WatchfaceResource } from './WatchfaceResource';
import { WatchfaceDescription } from './WatchfaceDescription';
import { WatchfaceManifest } from './WatchfaceManifest';
import { Description } from '@/types/watchface';
import { ensureDir } from '@/utils/fs/fs-extra.utils';
import { WatchfaceEditorConfig } from './WatchfaceEditorConfig';
import { WatchfacePreview } from './WatchfacePreview';
import { LayerUtils } from '@/utils/shape/layer.util';

export class WatchfaceService {
  private _path: string;
  get Path() {
    return this._path === '' ? useWatchfaceStore().path ?? '' : this._path;
  }
  get ResourcePath() {
    return ElectronApi.path?.join(this.Path, 'resources') || '';
  }
  get PreviewPath() {
    return ElectronApi.path?.join(this.Path, 'preview') || '';
  }
  /**
   * 返回manifest.xml所在路径
   */
  get manifestXmlPath() {
    return ElectronApi.path?.join(this.ResourcePath ?? '', 'manifest.xml');
  }
  /**
   * 返回description.xml文件路径
   */
  get descriptionXmlPath() {
    return ElectronApi.path?.join(this.Path, 'description.xml');
  }

  get editorConfigPath() {
    return ElectronApi.path?.join(this.Path, 'editor.config.json');
  }

  /**
   * 获取表盘默认保存目录
   * @returns
   */
  static async getSaveDir() {
    const res = ElectronApi.path?.join(
      await ElectronApi.getPath('userData'),
      'Watchfaces'
    );
    if (!res) throw '未获取到表盘默认目录';
    await ensureDir(res);
    return res;
  }

  static async create(watchfacePath: string, desc: Description) {
    const fs = ElectronApi.fs;
    const path = ElectronApi.path;
    if (!fs || !path) return;

    // 创建本地目录，并写入信息
    const service = new this(watchfacePath);
    await ensureDir(service.Path);
    await ensureDir(service.ResourcePath);
    await ensureDir(service.PreviewPath);
    await service.description.writeDecsriptionXML(desc, { mode: 'create' });
    // 写入themes
    await service.editorConfig.writeEditorData({
      themes: [LayerUtils.getEmptyThemeStyle()],
      i18n: { translations: {}, locales: [] }
    });
  }

  resource: WatchfaceResource;
  description: WatchfaceDescription;
  manifest: WatchfaceManifest;
  editorConfig: WatchfaceEditorConfig;
  preview: WatchfacePreview;
  constructor(path?: string) {
    this._path = path ?? '';
    this.resource = new WatchfaceResource(this.ResourcePath);
    this.description = new WatchfaceDescription(this.descriptionXmlPath ?? '');
    this.manifest = new WatchfaceManifest(this.manifestXmlPath ?? '');
    this.editorConfig = new WatchfaceEditorConfig(this.editorConfigPath ?? '');
    this.preview = new WatchfacePreview(this.PreviewPath ?? '');
  }
}
